import React from "react";

import { useImagePreview } from "../../../hooks";

// Превью изображения в формах витражных блоков.
// image — File (только что выбранный) или объект загрузчика с url (уже сохранённый)
// label — подпись над изображением, null чтобы не выводить
const ImagePreview = ({
  image,
  version,
  alt = "Изображение",
  label = "Текущее изображение:",
}) => {
  const src = useImagePreview(image, version);

  if (!src) {
    return null;
  }

  return (
    <p className="inline-hints">
      {label && (
        <>
          {label} <br />
        </>
      )}
      <img src={src} alt={alt} style={{ width: "200px", height: "auto" }} />
    </p>
  );
};

export default ImagePreview;
